import { render, staticRenderFns } from "./Personalinformation.vue?vue&type=template&id=0a024560&scoped=true&"
import script from "./Personalinformation.vue?vue&type=script&lang=js&"
export * from "./Personalinformation.vue?vue&type=script&lang=js&"
import style0 from "./Personalinformation.vue?vue&type=style&index=0&id=0a024560&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a024560",
  null
  
)

export default component.exports